import { LinkIcon } from "@heroicons/react/24/outline";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShareStatsButton = _ref => {
  let {
    handleClick
  } = _ref;
  return /*#__PURE__*/_jsxs("button", {
    onClick: handleClick,
    className: "rounded-lg px-4 py-2.5 font-mono sm:text-lg bg-green-200 hover:bg-green-300 text-white transition-all flex items-center justify-center gap-2",
    "data-testid": "share-results-footer",
    children: [/*#__PURE__*/_jsx(LinkIcon, {
      className: "w-4 h-4"
    }), "Share"]
  });
};